import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { getSingleCompany } from '../../redux/actions/company';
import { getSingleEmployee } from '../../redux/actions/employee';
import { deactivatedUser } from '../../redux/actions/user';

import CompanyDetailPage from './CompanyDetail.page';

const mapStateToProps = state => ({
  companyDetail: state.organization.companyDetail,
  employeeDetail: state.organization.detailEmployee,
  getLoading: state.organization.getLoading,
  me: state.auth.me,
});

const mapDispatchToProps = {
  getSingleCompany,
  deactivatedUser,
  getSingleEmployee,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CompanyDetailPage));
